export const songs = [
  {
    'name': 'Full moon (보름)',
    'path': '/music/full_moon.mp3',
    'url': 'https://music.feed-the-cat.stream/full_moon.mp3',
    'duration': 296,
    'artist': '전자양',
    'active': true,
  },
  {
    'name': 'The Whole Truth',
    'path': '/music/the_whole_truth.mp3',
    'url': 'https://music.feed-the-cat.stream/the_whole_truth.mp3',
    'duration': 168,
    'artist': 'deer park',
    'imageUrl': 'https://f4.bcbits.com/img/a2511641548_1x1_700.avif',
    'sourceUrl': 'https://deletedeletedeleted.bandcamp.com/track/the-whole-truth',
    'active': true,
  },
  {
    'name': 'Ya no me acuerdo',
    'path': '/music/ya_no_me_acuerdo.mp3',
    'url': 'https://music.feed-the-cat.stream/ya_no_me_acuerdo.mp3',
    'duration': 173,
    'artist': 'damoridemort',
    'imageUrl': 'https://f4.bcbits.com/img/a2865997687_10.jpg',
    'sourceUrl': 'https://damoridemort.bandcamp.com/track/ya-no-me-acuerdo',
    'active': true,
  },
  {
    'name': 'Pocion',
    'path': '/music/pocion.mp3',
    'url': 'https://music.feed-the-cat.stream/pocion.mp3',
    'duration': 124,
    'artist': 'damoridemort',
    'imageUrl': 'https://f4.bcbits.com/img/a2865997687_10.jpg',
    'sourceUrl': 'https://damoridemort.bandcamp.com/track/ya-no-me-acuerdo',
    'active': true,
  },
  {
    'name': 'La Boca del Cel',
    'duration': 242,
    'artist': 'damoridemort',
    'imageUrl': 'https://f4.bcbits.com/img/a2865997687_10.jpg',
    'sourceUrl': 'https://damoridemort.bandcamp.com/track/la-boca-del-cel',
    'active': true,
  },
  {
    'name': 'Letters and Packages',
    'path': '/music/letters_and_packages.mp3',
    'url': 'https://music.feed-the-cat.stream/letters_and_packages.mp3',
    'duration': 201,
    'artist': 'American Football',
    'imageUrl': 'https://f4.bcbits.com/img/a2753906385_16.jpg',
    'sourceUrl': 'https://americanfootball.bandcamp.com/track/letters-and-packages',
    'active': true,
  },
  {
    'name': '无病呻吟',
    'path': '/music/zebra.mp3',
    'url': 'https://music.feed-the-cat.stream/zebra.mp3',
    'duration': 147,
    'artist': 'jackzebra',
    'imageUrl': 'https://i.scdn.co/image/ab67616d0000b2734640f8eb27c5964995d9002f',
    'sourceUrl': 'https://soundcloud.com/jack-zebra',
    'active': true,
  },
  {
    'name': 'I Love Bugs',
    'path': '/music/i_love_bugs.mp3',
    'url': 'https://music.feed-the-cat.stream/i_love_bugs.mp3',
    'duration': 200,
    'artist': 'Twine',
    'imageUrl': 'https://f4.bcbits.com/img/a1190031962_10.jpg',
    'sourceUrl': 'https://twinemtl.bandcamp.com/track/i-love-bugs',
    'active': true,
  },
  {
    'name': 'Lo La',
    'path': '/music/lo_la.mp3',
    'url': 'https://music.feed-the-cat.stream/lo_la.mp3',
    'duration': 90,
    'artist': 'Mietze Conte, Otto Benson',
    'imageUrl': 'https://f4.bcbits.com/img/a3697901956_10.jpg',
    'sourceUrl': 'https://wnoadiarwb.bandcamp.com/track/lo-la',
    'active': true,
  },
  {
    'name': 'MOVING SINS',
    'path': '/music/moving_sins.mp3',
    'url': 'https://music.feed-the-cat.stream/moving_sins.mp3',
    'duration': 112,
    'artist': 'Voice Actor',
    'imageUrl': 'https://f4.bcbits.com/img/a0489885043_10.jpg',
    'sourceUrl': 'https://stroomtv.bandcamp.com/track/moving-sins',
    'active': true,
  },
  {
    'name': 'Cumbia Tornado',
    'path': '/music/cumbia_tornado.mp3',
    'url': 'https://music.feed-the-cat.stream/cumbia_tornado.mp3',
    'duration': 239,
    'artist': 'E+E',
    'imageUrl': 'https://lastfm.freetls.fastly.net/i/u/770x0/b2d4c9768ebc0b2f1270b2d9f51bc6a0.jpg#b2d4c9768ebc0b2f1270b2d9f51bc6a0',
    'sourceUrl': 'https://chuquimamani-condori.bandcamp.com/',
    'active': true,
  },
  {
    'name': 'Mándame una señal',
    'path': '/music/mandame_una_senal.mp3',
    'url': 'https://music.feed-the-cat.stream/mandame_una_senal.mp3',
    'duration': 260,
    'artist': 'Rebe',
    'imageUrl': 'https://images.genius.com/205097e97ca3f2d741e4c00f46f26508.500x500x1.jpg',
    'sourceUrl': 'https://rebe.bandcamp.com/',
    'active': true,
  },
  {
    'name': 'Apple',
    'path': '/music/apple.mp3',
    'url': 'https://music.feed-the-cat.stream/apple.mp3',
    'duration': 104,
    'artist': 'Bladee',
    'imageUrl': 'https://cdn-images.dzcdn.net/images/cover/878e17b275860fa4bc9a58483b221291/500x500-000000-80-0-0.jpg',
    'sourceUrl': 'https://soundcloud.com/bladee1000',
    'active': true,
  },
  {
    'name': 'Could be us',
    'path': '/music/could_be_us.mp3',
    'url': 'https://music.feed-the-cat.stream/could_be_us.mp3',
    'duration': 251,
    'artist': 'Whitearmor',
    'imageUrl': 'https://images.genius.com/d19d6ffbfedb45314fd4d3d69190a4f8.1000x1000x1.jpg',
    'sourceUrl': 'https://soundcloud.com/whitearmor-music',
    'active': true,
  },
  {
    'name': 'Slow dance',
    'path': '/music/slow_dance.mp3',
    'url': 'https://music.feed-the-cat.stream/slow_dance.mp3',
    'duration': 189,
    'artist': 'Whitearmor',
    'imageUrl': 'https://images.genius.com/d19d6ffbfedb45314fd4d3d69190a4f8.1000x1000x1.jpg',
    'sourceUrl': 'https://soundcloud.com/whitearmor-music',
    'active': true,
  },
  {
    'name': 'Längtan Får Vingar',
    'path': '/music/langtan_far_vingar.mp3',
    'url': 'https://music.feed-the-cat.stream/langtan_far_vingar.mp3',
    'duration': 165,
    'artist': 'VilloVilduVeta',
    'imageUrl': 'https://f4.bcbits.com/img/a1929124658_16.jpg',
    'sourceUrl': 'https://year0001.bandcamp.com/album/l-ngtan-f-r-vingar',
    'active': true,
  },
  {
    'name': '5',
    'path': '/music/05.mp3',
    'url': 'https://music.feed-the-cat.stream/05.mp3',
    'duration': 263,
    'artist': 'Color Plus',
    'imageUrl': 'https://f4.bcbits.com/img/a537024087_1x1_700.avif',
    'sourceUrl': 'https://colorplus.bandcamp.com/track/5',
    'active': true,
  },
  {
    'name': 'intro 3',
    'path': '/music/intro_3.mp3',
    'url': 'https://music.feed-the-cat.stream/intro_3.mp3',
    'duration': 97,
    'artist': 'walmart',
    'active': false,
  },
  {
    'name': '20240329.0',
    'path': '/music/20240329_0.mp3',
    'url': 'https://music.feed-the-cat.stream/20240329_0.mp3',
    'duration': 182,
    'artist': '3D Shape',
    'imageUrl': 'https://i1.sndcdn.com/artworks-D04nL5HCkpancDqk-CDhW5Q-t1080x1080.jpg',
    'sourceUrl': 'https://soundcloud.com/3d_shape/20240329-0-wip-4',
    'active': true,
  },
  {
    'name': '20240715.0',
    'path': '/music/20240715_0.mp3',
    'url': 'https://music.feed-the-cat.stream/20240715_0.mp3',
    'duration': 198,
    'artist': '3D Shape',
    'imageUrl': 'https://i1.sndcdn.com/artworks-Dj3j6q69mSLt477K-RzBJzg-t1080x1080.jpg',
    'sourceUrl': 'https://soundcloud.com/3d_shape/202407150wip2',
    'active': true,
  },
  {
    'name': 'Warm Soft Things',
    'path': '/music/warm_soft_things.mp3',
    'url': 'https://music.feed-the-cat.stream/warm_soft_things.mp3',
    'duration': 105,
    'artist': 'Inchworm Race At Sunrise',
    'imageUrl': 'https://f4.bcbits.com/img/a1562056343_1x1_700.avif',
    'sourceUrl': 'https://rosemelbergfanclub.bandcamp.com/track/warm-soft-things',
    'active': true,
  },
  {
    'name': 'Clouds Are Clouds, Trees Are Trees',
    'path': '/music/clouds_are_clouds.mp3',
    'url': 'https://music.feed-the-cat.stream/clouds_are_clouds.mp3',
    'duration': 109,
    'artist': 'Inchworm Race At Sunrise',
    'imageUrl': 'https://f4.bcbits.com/img/a1562056343_1x1_700.avif',
    'sourceUrl': 'https://rosemelbergfanclub.bandcamp.com/track/clouds-are-clouds-trees-are-trees',
    'active': true,
  },
  {
    'name': 'Love Song',
    'url': 'https://music.feed-the-cat.stream/Love%20Song.mp3',
    'duration': 109,
    'artist': 'Inchworm Race At Sunrise',
    'imageUrl': 'https://f4.bcbits.com/img/a1562056343_1x1_700.avif',
    'sourceUrl': 'https://rosemelbergfanclub.bandcamp.com/track/love-song',
    'active': true,
  },
  {
    'name': 'Meow',
    'path': '/music/meow.mp3',
    'url': 'https://music.feed-the-cat.stream/meow.mp3',
    'duration': 131,
    'artist': 'vivi milne',
    'imageUrl': 'https://i1.sndcdn.com/artworks-ugtRiSrA4dZysEEA-83nAEg-t1080x1080.jpg',
    'sourceUrl': 'https://soundcloud.com/vivimilne',
    'active': true,
  },
  {
    'name': "I'm Too Sleepy... Shall We Swim?",
    'path': '/music/sleepy.mp3',
    'url': 'https://music.feed-the-cat.stream/sleepy.mp3',
    'duration': 314,
    'artist': 'Belong',
    'imageUrl': 'https://f4.bcbits.com/img/a2918124824_1x1_700.avif',
    'sourceUrl': 'https://spectrumspools.bandcamp.com/track/im-too-sleepy-shall-we-swim',
    'active': true,
  },
  {
    'name': 'morning dew',
    'path': '/music/morning_dew.mp3',
    'url': 'https://music.feed-the-cat.stream/morning_dew.mp3',
    'duration': 69,
    'artist': 'nykolaes, Daniël Paul',
    'imageUrl': 'https://f4.bcbits.com/img/a2646808454_1x1_700.avif',
    'sourceUrl': 'https://toverberglabel.bandcamp.com/track/morning-dew',
    'active': true,
  },
  {
    'name': 'wishing',
    'path': '/music/wishing.mp3',
    'url': 'https://music.feed-the-cat.stream/wishing.mp3',
    'duration': 70,
    'artist': 'syrup',
    'imageUrl': 'https://f4.bcbits.com/img/a114757656_1x1_700.avif',
    'sourceUrl': 'https://wishing.bandcamp.com/track/syrup',
    'active': true,
  },
  {
    'name': 'Heart Eyes',
    'path': '/music/heart_eyes.mp3',
    'url': 'https://music.feed-the-cat.stream/heart_eyes.mp3',
    'duration': 185,
    'artist': 'Hooky',
    'imageUrl': 'https://f4.bcbits.com/img/a4250244528_1x1_700.avif',
    'sourceUrl': 'https://hoooky.bandcamp.com/track/heart-eyes',
    'active': true,
  },
  {
    'name': 'burnt to the ground in this cityscape',
    'path': '/music/burnt.mp3',
    'url': 'https://music.feed-the-cat.stream/burnt.mp3',
    'duration': 117,
    'artist': 'Forma Norte',
    'imageUrl': 'https://f4.bcbits.com/img/a782945206_1x1_700.avif',
    'sourceUrl': 'https://formanorte.bandcamp.com/track/burnt-to-the-ground-in-this-cityscape',
    'active': true,
  },
  {
    'name': 'horseshoe',
    'path': '/music/horseshoe.mp3',
    'url': 'https://music.feed-the-cat.stream/horseshoe.mp3',
    'duration': 137,
    'artist': 'Hooky, Winter',
    'imageUrl': 'https://f4.bcbits.com/img/a872676441_1x1_700.avif',
    'sourceUrl': 'https://daydreamingwinter.bandcamp.com/track/horseshoe',
    'active': true,
  },
  {
    'name': 'in your pocket',
    'path': '/music/in_your_pocket.mp3',
    'url': 'https://music.feed-the-cat.stream/in_your_pocket.mp3',
    'duration': 135,
    'artist': 'Hooky, Winter',
    'imageUrl': 'https://f4.bcbits.com/img/a872676441_1x1_700.avif',
    'sourceUrl': 'https://daydreamingwinter.bandcamp.com/track/in-your-pocket',
    'active': true,
  },
  {
    'name': 'Air conditioning',
    'path': '/music/air_conditioning.mp3',
    'url': 'https://music.feed-the-cat.stream/air_conditioning.mp3',
    'duration': 185,
    'artist': 'Tek lintowe',
    'active': false,
  },
  {
    'name': 'In are hearts',
    'duration': 70,
    'artist': 'Tek lintowe',
    'imageUrl': 'https://i1.sndcdn.com/artworks-5ZgzfFVS6SarLjnA-AXaVfQ-t1080x1080.jpg',
    'sourceUrl': 'https://soundcloud.com/teklintowe/in-are-hearts?in=teklintowe/sets/kill-you',
    'active': true,
  },
  {
    'name': 'Unlenting',
    'path': '/music/unlenting.mp3',
    'url': 'https://music.feed-the-cat.stream/unlenting.mp3',
    'duration': 133,
    'artist': 'Tek lintowe',
    'imageUrl': 'https://f4.bcbits.com/img/a3300491430_1x1_700.avif',
    'sourceUrl': 'https://teklintowe.bandcamp.com/track/hatsune-miku-unlenting-teklintowe-p-ft-shotti-p',
    'active': true,
  },
  {
    'name': "there's someone in this room just like you",
    'path': '/music/room.mp3',
    'url': 'https://music.feed-the-cat.stream/room.mp3',
    'duration': 100,
    'artist': 'lots of hands',
    'imageUrl': 'https://f4.bcbits.com/img/a4037338990_1x1_700.avif',
    'sourceUrl': 'https://lotsofhands.bandcamp.com/album/theres-someone-in-this-room-just-like-you',
    'active': true,
  },
  {
    'name': 'Breathing',
    'path': '/music/breathing.mp3',
    'url': 'https://music.feed-the-cat.stream/breathing.mp3',
    'duration': 258,
    'artist': 'Chuquimamani-Condori',
    'imageUrl': 'https://f4.bcbits.com/img/a2767463016_1x1_700.avif',
    'sourceUrl': 'https://chuquimamani-condori.bandcamp.com/track/breathing',
    'active': true,
  },
  {
    'name': 'still life',
    'path': '/music/still-life.mp3',
    'url': 'https://music.feed-the-cat.stream/still-life.mp3',
    'duration': 268,
    'artist': 'Kazuma Sugawara',
    'imageUrl': 'https://f4.bcbits.com/img/a2171072764_1x1_700.avif',
    'sourceUrl': 'https://eneiongaku.bandcamp.com/track/still-life',
    'active': true,
  },
  {
    'name': "Kitty's Midnight Blessing",
    'path': '/music/midnight-blessing.mp3',
    'url': 'https://music.feed-the-cat.stream/midnight-blessing.mp3',
    'duration': 195,
    'artist': 'Otto Benson',
    'imageUrl': 'https://f4.bcbits.com/img/a3523833494_1x1_700.avif',
    'sourceUrl': 'https://wnoadiarwb.bandcamp.com/track/kittys-midnight-blessing',
    'active': true,
  },
  {
    'name': 'waiting for u',
    'path': '/music/waiting_for_u.mp3',
    'url': 'https://music.feed-the-cat.stream/waiting_for_u.mp3',
    'duration': 234,
    'artist': 'sex',
    'imageUrl': 'https://f4.bcbits.com/img/a1884604506_1x1_700.avif',
    'sourceUrl': 'https://appendixfiles.bandcamp.com/track/waiting-for-u',
    'active': true,
  },
  {
    'name': '移民の歌',
    'path': '/music/happyender.mp3',
    'url': 'https://music.feed-the-cat.stream/happyender.mp3',
    'duration': 134,
    'artist': 'ex. happyender girl',
    'imageUrl': 'https://f4.bcbits.com/img/a4263840096_1x1_700.avif',
    'sourceUrl': 'https://happyender-girl.bandcamp.com/track/--120',
    'active': true,
  },
  {
    'name': 'it reminds me of U',
    'path': '/music/reminds_me.mp3',
    'url': 'https://music.feed-the-cat.stream/reminds_me.mp3',
    'duration': 203,
    'artist': 'innerinnerlife',
    'imageUrl': 'https://f4.bcbits.com/img/a1791927733_1x1_700.avif',
    'sourceUrl': 'https://innerinnerlife.bandcamp.com/track/this-reminds-me-of-u',
    'active': true,
  },
  {
    'name': 'Spring Dream',
    'path': '/music/spring-dream.mp3',
    'url': 'https://music.feed-the-cat.stream/spring-dream.mp3',
    'duration': 178,
    'artist': '1LDK',
    'imageUrl': 'https://f4.bcbits.com/img/a3161964520_1x1_700.avif',
    'sourceUrl': 'https://1ldk.bandcamp.com/track/spring-dream',
    'active': true,
  },
  {
    'name': 'Clouds',
    'path': '/music/clouds.mp3',
    'url': 'https://music.feed-the-cat.stream/clouds.mp3',
    'duration': 207,
    'artist': 'Cibo Matto',
    'active': false,
  },
  {
    'name': 'crisp dubs',
    'path': '/music/crisp_dubs.mp3',
    'url': 'https://music.feed-the-cat.stream/crisp_dubs.mp3',
    'duration': 202,
    'artist': 'xaviersobased',
    'imageUrl': 'https://i1.sndcdn.com/artworks-2vqanhdH08ebGHTH-Y2X6gA-t1080x1080.jpg',
    'sourceUrl': 'https://soundcloud.com/xaviersobased/crisp-dubs-xaviersobased',
    'active': true,
  },
  {
    'name': 'Chu Chu',
    'path': '/music/chu_chu.mp3',
    'url': 'https://music.feed-the-cat.stream/chu_chu.mp3',
    'duration': 160,
    'artist': 'emeel',
    'imageUrl': 'https://f4.bcbits.com/img/a3791328391_1x1_700.avif',
    'sourceUrl': 'https://emeel.bandcamp.com/track/chu-chu',
    'active': true,
  },
  {
    'name': '산 san',
    'path': '/music/san.mp3',
    'url': 'https://music.feed-the-cat.stream/san.mp3',
    'duration': 127,
    'artist': 'khc',
    'imageUrl': 'https://f4.bcbits.com/img/a1207908081_10.jpg',
    'sourceUrl': 'https://khchoi.bandcamp.com/track/san',
    'active': true,
  },
  {
    'name': 'Tiny Planet',
    'path': '/music/tiny_planet.mp3',
    'url': 'https://music.feed-the-cat.stream/tiny_planet.mp3',
    'duration': 224,
    'artist': 'emeel',
    'imageUrl': 'https://f4.bcbits.com/img/a2931005248_1x1_700.avif',
    'sourceUrl': 'https://emeel.bandcamp.com/track/tiny-planet',
    'active': true,
  },
  {
    'name': 'two moons',
    'path': '/music/two_moons.mp3',
    'url': 'https://music.feed-the-cat.stream/two_moons.mp3',
    'duration': 250,
    'artist': 'toe',
    'imageUrl': 'https://f4.bcbits.com/img/a4127161963_1x1_700.avif',
    'sourceUrl': 'https://toe-music.bandcamp.com/track/two-moons',
    'active': true,
  },
  {
    'name': 'Fish',
    'path': '/music/fish.mp3',
    'url': 'https://music.feed-the-cat.stream/fish.mp3',
    'duration': 70,
    'artist': 'Pencil Legs',
    'imageUrl': 'https://f4.bcbits.com/img/a125897100_1x1_700.avif',
    'sourceUrl': 'https://pencillegs.bandcamp.com/track/fish',
    'active': true,
  },
  {
    'name': 'Intro',
    'path': '/music/intro.mp3',
    'url': 'https://music.feed-the-cat.stream/intro.mp3',
    'duration': 71,
    'artist': 'Sonic Youth',
    'active': false,
  },
  {
    'name': 'Light Dreams',
    'path': '/music/light_dreams.mp3',
    'url': 'https://music.feed-the-cat.stream/light_dreams.mp3',
    'duration': 230,
    'artist': 'Haunted Tape, Orchid Mantis',
    'active': false,
  },
  {
    'name': 'Aim',
    'path': '/music/aim.mp3',
    'url': 'https://music.feed-the-cat.stream/aim.mp3',
    'duration': 95,
    'artist': 'ear',
    'active': false,
  },
  {
    'name': 'scrubby',
    'path': '/music/scrubby.mp3',
    'url': 'https://music.feed-the-cat.stream/scrubby.mp3',
    'duration': 102,
    'artist': 'Ulla',
    'imageUrl': 'https://f4.bcbits.com/img/a2199026417_1x1_700.avif',
    'sourceUrl': 'https://ullastraus.bandcamp.com/track/scrubby-2',
    'active': true,
  },
  {
    'name': 'Publix',
    'path': '/music/publix.mp3',
    'url': 'https://music.feed-the-cat.stream/publix.mp3',
    'duration': 115,
    'artist': 'Hooky',
    'imageUrl': 'https://f4.bcbits.com/img/a113267783_1x1_700.avif',
    'sourceUrl': 'https://hoooky.bandcamp.com/track/publix',
    'active': true,
  },
  {
    'name': 'song',
    'path': '/music/song.mp3',
    'url': 'https://music.feed-the-cat.stream/song.mp3',
    'duration': 122,
    'artist': 'Ulla',
    'imageUrl': 'https://f4.bcbits.com/img/a2199026417_1x1_700.avif',
    'sourceUrl': 'https://ullastraus.bandcamp.com/track/song-2',
    'active': true,
  },
  {
    'name': 'Vega',
    'path': '/music/vega.mp3',
    'url': 'https://music.feed-the-cat.stream/vega.mp3',
    'duration': 129,
    'artist': 'ESP',
    'imageUrl': 'https://f4.bcbits.com/img/a3241925378_1x1_700.avif',
    'sourceUrl': 'https://espforever.bandcamp.com/track/vega',
    'active': true,
  },
  {
    'name': 'ArchangeL',
    'path': '/music/archangel.mp3',
    'url': 'https://music.feed-the-cat.stream/archangel.mp3',
    'duration': 135,
    'artist': 'Vova Polunin',
    'active': false,
  },
  {
    'name': 'LOVESTORY',
    'path': '/music/lovestory.mp3',
    'url': 'https://music.feed-the-cat.stream/lovestory.mp3',
    'duration': 136,
    'artist': 'Bladee, Ecco2k',
    'imageUrl': 'https://i1.sndcdn.com/artworks-EQKYJkfdqO2i-0-t1080x1080.png',
    'sourceUrl': 'https://soundcloud.com/bladee1000/lovestory-feat-ecco2k',
    'active': true,
  },
  {
    'name': 'ugly man fun plan',
    'path': '/music/ugly_man.mp3',
    'url': 'https://music.feed-the-cat.stream/ugly_man.mp3',
    'duration': 151,
    'artist': 'lots of hands',
    'imageUrl': 'https://f4.bcbits.com/img/a1215586825_1x1_700.avif',
    'sourceUrl': 'https://lotsofhands.bandcamp.com/track/ugly-man-fun-plan-2',
    'active': true,
  },
  {
    'name': 'Sepia Rainbow',
    'path': '/music/sepia_rainbow.mp3',
    'url': 'https://music.feed-the-cat.stream/sepia_rainbow.mp3',
    'duration': 190,
    'artist': 'Apu Nanu',
    'active': false,
  },
  {
    'name': 'i_met_ur_sister_through_her_iPod_in_2009.mp3',
    'path': '/music/ipod_2009.mp3',
    'url': 'https://music.feed-the-cat.stream/ipod_2009.mp3',
    'duration': 192,
    'artist': 'mieke',
    'active': false,
  },
  {
    'name': 'Bamboo Dj Tool',
    'path': '/music/bamboo.mp3',
    'url': 'https://music.feed-the-cat.stream/bamboo.mp3',
    'duration': 203,
    'artist': 'Monker178',
    'imageUrl': 'https://f4.bcbits.com/img/a1074621744_1x1_700.avif',
    'sourceUrl': 'https://clubparadiso.bandcamp.com/track/monker178-bamboo-dj-tool',
    'active': true,
  },
  {
    'name': 'Kisses and Hugs',
    'path': '/music/kisses_and_hugs.mp3',
    'url': 'https://music.feed-the-cat.stream/kisses_and_hugs.mp3',
    'duration': 219,
    'artist': 'Whitearmor',
    'imageUrl': 'https://i1.sndcdn.com/artworks-z5cn1nI1lNj2-0-t1080x1080.png',
    'sourceUrl': 'https://soundcloud.com/whitearmor-music/kisses-and-hugs',
    'active': true,
  },
  {
    'name': 'No One Dances Quite Like My Brothers',
    'path': '/music/no_one_dances.mp3',
    'url': 'https://music.feed-the-cat.stream/no_one_dances.mp3',
    'duration': 221,
    'artist': 'Vår',
    'active': false,
  },
  {
    'name': 'running late',
    'path': '/music/running_late.mp3',
    'url': 'https://music.feed-the-cat.stream/running_late.mp3',
    'duration': 35,
    'artist': 'wist',
    'imageUrl': 'https://f4.bcbits.com/img/a2696466501_1x1_700.avif',
    'sourceUrl': 'https://stroomtv.bandcamp.com/track/running-late',
    'active': true,
  },
  {
    'name': 'respite',
    'path': '/music/respite.mp3',
    'url': 'https://music.feed-the-cat.stream/respite.mp3',
    'duration': 3,
    'artist': 'wist',
    'imageUrl': 'https://f4.bcbits.com/img/a2696466501_1x1_700.avif',
    'sourceUrl': 'https://stroomtv.bandcamp.com/track/respite',
    'active': true,
  },
  {
    'name': 'in no time...',
    'path': '/music/in_no_time.mp3',
    'url': 'https://music.feed-the-cat.stream/in_no_time.mp3',
    'duration': 88,
    'artist': 'wist',
    'imageUrl': 'https://f4.bcbits.com/img/a2696466501_1x1_700.avif',
    'sourceUrl': 'https://stroomtv.bandcamp.com/track/in-no-time',
    'active': true,
  },
  {
    'name': 'walk by the lake',
    'path': '/music/walk_by_the_lake.mp3',
    'url': 'https://music.feed-the-cat.stream/walk_by_the_lake.mp3',
    'duration': 58,
    'artist': 'wist',
    'imageUrl': 'https://f4.bcbits.com/img/a2696466501_1x1_700.avif',
    'sourceUrl': 'https://stroomtv.bandcamp.com/track/walk-by-the-lake',
    'active': true,
  },
  {
    'name': 'FIRE GUT',
    'path': '/music/fire_gut.mp3',
    'url': 'https://music.feed-the-cat.stream/fire_gut.mp3',
    'duration': 226,
    'artist': 'E+E',
    'active': false,
  },
  {
    'name': '왜?',
    'path': '/music/why.mp3',
    'url': 'https://music.feed-the-cat.stream/why.mp3',
    'duration': 281,
    'artist': 'Mid-Air Thief',
    'active': false,
  },
  {
    'name': 'MACCAU CELEBRITIES',
    'path': '/music/maccau.mp3',
    'url': 'https://music.feed-the-cat.stream/maccau.mp3',
    'duration': 315,
    'artist': 'BEBETUNE$',
    'active': false,
  },
  {
    'name': 'Smile',
    'path': '/music/smile.mp3',
    'url': 'https://music.feed-the-cat.stream/smile.mp3',
    'duration': 211,
    'artist': 'Elysia Crampton',
    'imageUrl': 'https://f4.bcbits.com/img/a2841433353_1x1_700.avif',
    'sourceUrl': 'https://wehatemusic.bandcamp.com/track/smile-2012',
    'active': true,
  },
  {
    'name': 'Aeonic Summons',
    'path': '/music/summons.mp3',
    'url': 'https://music.feed-the-cat.stream/summons.mp3',
    'duration': 270,
    'artist': 'Anee Molly',
    'active': false,
  },
  {
    'name': 'M A D N E $ $',
    'path': '/music/madness.mp3',
    'url': 'https://music.feed-the-cat.stream/madness.mp3',
    'duration': 282,
    'artist': 'BEBETUNE$',
    'active': false,
  },
  {
    'name': '++ ｡♡☆ حبيبي',
    'path': '/music/ruuuuuuuuush.mp3',
    'url': 'https://music.feed-the-cat.stream/ruuuuuuuuush.mp3',
    'duration': 161,
    'artist': 'Ruuuuuuuuush',
    'active': false,
  },
  {
    'name': '3030303',
    'path': '/music/3030303.mp3',
    'url': 'https://music.feed-the-cat.stream/3030303.mp3',
    'duration': 116,
    'artist': 'snafu',
    'active': false,
  },
  {
    'name': 'Callcenter',
    'path': '/music/callcenter.mp3',
    'url': 'https://music.feed-the-cat.stream/callcenter.mp3',
    'duration': 98,
    'artist': 'Amigos Imaginarios',
    'imageUrl': 'https://f4.bcbits.com/img/a2295094894_1x1_700.avif',
    'sourceUrl': 'https://budtapes.bandcamp.com/track/callcenter',
    'active': true,
  },
  {
    'name': 'Fou De Toi',
    'path': '/music/fou.mp3',
    'url': 'https://music.feed-the-cat.stream/fou.mp3',
    'duration': 135,
    'artist': 'EYE',
    'imageUrl': 'https://f4.bcbits.com/img/a1087596509_1x1_700.avif',
    'sourceUrl': 'https://knekelhuis.bandcamp.com/track/fou-de-toi',
    'active': true,
  },
  {
    'name': 'Lamborghini (Petrol April 1982)',
    'path': '/music/lamborghini.mp3',
    'url': 'https://music.feed-the-cat.stream/lamborghini.mp3',
    'duration': 236,
    'artist': 'Severed Heads',
    'imageUrl': 'https://f4.bcbits.com/img/a2654729214_1x1_700.avif',
    'sourceUrl': 'https://chaptermusic.bandcamp.com/track/lamborghini',
    'active': true,
  },
  {
    'name': 'The Little Bubble',
    'path': '/music/bubble.mp3',
    'url': 'https://music.feed-the-cat.stream/bubble.mp3',
    'duration': 113,
    'artist': 'Amigos Imaginarios',
    'imageUrl': 'https://f4.bcbits.com/img/a337867141_1x1_700.avif',
    'sourceUrl': 'https://budtapes.bandcamp.com/track/the-little-bubble',
    'active': true,
  },
  {
    'name': 'Swim',
    'path': '/music/swim.mp3',
    'url': 'https://music.feed-the-cat.stream/swim.mp3',
    'duration': 250,
    'artist': 'Ideasforconversations',
    'imageUrl': 'https://f4.bcbits.com/img/0038405590_21.jpg',
    'sourceUrl': 'https://ideasforconversations.bandcamp.com/',
    'active': true,
  },
  {
    'name': 'Promis',
    'path': '/music/promis.mp3',
    'url': 'https://music.feed-the-cat.stream/promis.mp3',
    'duration': 258,
    'artist': 'Ideasforconversations',
    'imageUrl': 'https://f4.bcbits.com/img/a2977310949_1x1_700.avif',
    'sourceUrl': 'https://ideasforconversations.bandcamp.com/track/promise-i4c',
    'active': true,
  },
  {
    'name': '오후 in the afternoon',
    'path': '/music/afternoon.mp3',
    'url': 'https://music.feed-the-cat.stream/afternoon.mp3',
    'duration': 172,
    'artist': 'khc',
    'imageUrl': 'https://f4.bcbits.com/img/a1207908081_1x1_700.avif',
    'sourceUrl': 'https://khchoi.bandcamp.com/track/in-the-afternoon',
    'active': true,
  },
  {
    'name': 'Another Sleepy Morning',
    'path': '/music/sleepy_morning.mp3',
    'url': 'https://music.feed-the-cat.stream/sleepy_morning.mp3',
    'duration': 90,
    'artist': 'The Happies',
    'active': false,
  },
  {
    'name': 'Beach song',
    'path': '/music/beach_song.mp3',
    'url': 'https://music.feed-the-cat.stream/beach_song.mp3',
    'duration': 88,
    'artist': 'bbpue',
    'active': false,
  },
  {
    'name': '150 bpm',
    'path': '/music/150_bpm.mp3',
    'url': 'https://music.feed-the-cat.stream/150_bpm.mp3',
    'duration': 116,
    'artist': 'find my friends',
    'active': false,
  },
  {
    'name': 'Jellyfish Blues',
    'path': '/music/jellyfish_blues.mp3',
    'url': 'https://music.feed-the-cat.stream/jellyfish_blues.mp3',
    'duration': 196,
    'artist': 'Buffalo Daughter',
    'imageUrl': 'https://f4.bcbits.com/img/a2744692274_1x1_700.avif',
    'sourceUrl': 'https://buffalodaughter.bandcamp.com/track/jellyfish-blues',
    'active': true,
  },
  {
    'name': 'Starry Cat',
    'path': '/music/starry_cat.mp3',
    'url': 'https://music.feed-the-cat.stream/starry_cat.mp3',
    'duration': 101,
    'artist': 'Starry Cat',
    'imageUrl': 'https://f4.bcbits.com/img/a1678638806_1x1_700.avif',
    'sourceUrl': 'https://starrycat.bandcamp.com/track/starry-cat',
    'active': true,
  },
  {
    'name': 'Destrozar el Mundo para Levantar Otro Más Verdadero',
    'path': '/music/destrozar_el_mundo.mp3',
    'url': 'https://music.feed-the-cat.stream/destrozar_el_mundo.mp3',
    'duration': 116,
    'artist': 'El Príncipe Idiota',
    'imageUrl': 'https://f4.bcbits.com/img/a4140894578_1x1_700.avif',
    'sourceUrl': 'https://principeidiota.bandcamp.com/track/destrozar-el-mundo-para-levantar-otro-mas-verdadero',
    'active': true,
  },
  {
    'name': "I Missed You Until I Didn't",
    'path': '/music/i_missed_you.mp3',
    'url': 'https://music.feed-the-cat.stream/i_missed_you.mp3',
    'duration': 131,
    'artist': 'cehryl',
    'imageUrl': 'https://f4.bcbits.com/img/a1851477294_1x1_700.avif',
    'sourceUrl': 'https://cehryl.bandcamp.com/track/i-missed-you-until-i-didnt',
    'active': true,
  },
  {
    'name': 'a ver perense tantito',
    'path': '/music/tantito.mp3',
    'url': 'https://music.feed-the-cat.stream/tantito.mp3',
    'duration': 126,
    'artist': 'Perritos Genéricos',
    'imageUrl': 'https://f4.bcbits.com/img/a2187795196_1x1_700.avif',
    'sourceUrl': 'https://perritosgenericos.bandcamp.com/track/a-ver-perense-tantito',
    'active': true,
  },
  {
    'name': '1967 Urban Renewal Project',
    'path': '/music/1967_Urban.mp3',
    'url': 'https://music.feed-the-cat.stream/1967_Urban.mp3',
    'duration': 420,
    'artist': 'Bug Bus Piano',
    'imageUrl': 'https://f4.bcbits.com/img/a2230039158_10.jpg',
    'sourceUrl': 'https://bugbuspiano.bandcamp.com/track/1967-urban-renewal-project',
    'active': true,
  },
  {
    'name': '地下鉄の動態',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/subway.mp3',
    'duration': 246,
    'artist': 'haisuinonasa',
    'imageUrl': 'https://f4.bcbits.com/img/a3412404081_2.jpg',
    'sourceUrl': 'https://zankyorecord.bandcamp.com/track/dynamics-of-subway',
    'active': true,
  },
  {
    'name': 'Canticle Hardposte',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/hardposte.mp3',
    'duration': 195,
    'artist': 'Proc Fiskal',
    'imageUrl': 'https://f4.bcbits.com/img/a3132930208_2.jpg',
    'sourceUrl': 'https://procfiskal.bandcamp.com/track/canticle-hardposte',
    'active': true,
  },
  {
    'name': 'Prromise',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/prromise.mp3',
    'duration': 147,
    'artist': 'Mietze Conte, Otto Benson',
    'imageUrl': 'https://f4.bcbits.com/img/a3697901956_2.jpg',
    'sourceUrl': 'https://wnoadiarwb.bandcamp.com/track/prromise',
    'active': true,
  },
  {
    'name': 'Night Ela (Mystic Thing)',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/night_ela.mp3',
    'duration': 302,
    'artist': 'Candy Claws',
    'imageUrl': 'https://f4.bcbits.com/img/a2574521960_2.jpg',
    'sourceUrl': 'https://candyclaws.bandcamp.com/track/night-ela-mystic-thing',
    'active': true,
  },
  {
    'name': 'Birds Of A Feather',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/birds_of_a_feather.mp3',
    'duration': 209,
    'artist': 'Kind Of Like Spitting',
    'imageUrl': 'https://f4.bcbits.com/img/a0130339604_2.jpg',
    'sourceUrl': 'https://kolsband.bandcamp.com/track/birds-of-a-feather-3',
    'active': true,
  },
  {
    'name': 'Everything Under The Sun',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/ev_under_the_sun.mp3',
    'duration': 333,
    'artist': 'Placid Angels',
    'imageUrl': 'https://f4.bcbits.com/img/a1414063571_2.jpg',
    'sourceUrl': 'https://peacefrog.bandcamp.com/track/everything-under-the-sun',
    'active': true,
  },
  {
    'name': 'I fucked up',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/i_fucked_up.mp3',
    'duration': 167,
    'artist': 'ssaliva',
    'imageUrl': 'https://f4.bcbits.com/img/a3251292052_2.jpg',
    'sourceUrl': 'https://ssaliva.bandcamp.com/track/i-fucked-up-2',
    'active': true,
  },
  {
    'name': 'Isle of Us',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/isle_of_us.mp3',
    'duration': 156,
    'artist': 'Malibu',
    'imageUrl': 'https://f4.bcbits.com/img/a2811577184_2.jpg',
    'sourceUrl': 'https://geographicnorth.bandcamp.com/track/malibu-isle-of-us',
    'active': true,
  },
  {
    'name': 'A World Beyond Lashes',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/world_beyond_lashes.mp3',
    'duration': 128,
    'artist': 'Malibu',
    'imageUrl': 'https://f4.bcbits.com/img/a4229798352_2.jpg',
    'sourceUrl': 'https://mmmmalibu.bandcamp.com/track/a-world-beyond-lashes',
    'active': true,
  },
  {
    'name': 'Frutta E Verdura',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/frutta_e_verdura.mp3',
    'duration': 184,
    'artist': 'Whitearmor, Gud',
    'imageUrl': 'https://i1.sndcdn.com/artworks-UqH1EvGW4HSP-0-t500x500.png',
    'sourceUrl': 'https://soundcloud.com/whitearmor-music/frutta-e-verdura',
    'active': true,
  },
  {
    'name': 'Blush',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/blush.mp3',
    'duration': 230,
    'artist': 'Wilson Tanner',
    'imageUrl': 'https://f4.bcbits.com/img/a3331560479_2.jpg',
    'sourceUrl': 'https://wilsontanner.bandcamp.com/track/blush-2',
    'active': true,
  },
  {
    'name': 'CMYL',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/CMYL.mp3',
    'duration': 267,
    'artist': 'tau contrib',
    'imageUrl': 'https://f4.bcbits.com/img/a0720050154_2.jpg',
    'sourceUrl': 'https://taucontrib.bandcamp.com/track/cmyl',
    'active': true,
  },
  {
    'name': 'Mirror Talk',
    'path': '231',
    'url': 'https://music.feed-the-cat.stream/mirror_talk.mp3',
    'duration': 238,
    'artist': 'tau contrib',
    'imageUrl': 'https://f4.bcbits.com/img/a2504412258_2.jpg',
    'sourceUrl': 'https://slagwerk.bandcamp.com/track/mirror-talk',
    'active': true,
  },
  {
    'name': 'Narcopop',
    'path': '231',
    'url': 'https://music.feed-the-cat.stream/narcopop.mp3',
    'duration': 295,
    'artist': 'tau contrib',
    'imageUrl': 'https://f4.bcbits.com/img/a2504412258_2.jpg',
    'sourceUrl': 'https://slagwerk.bandcamp.com/track/narcopop',
    'active': true,
  },
  {
    'name': 'Mirror / Candle',
    'path': '231',
    'url': 'https://music.feed-the-cat.stream/mirror_candle.mp3',
    'duration': 333,
    'artist': 'what is your name?',
    'imageUrl': 'https://f4.bcbits.com/img/a2797035787_2.jpg',
    'sourceUrl': 'https://whatisyourname.bandcamp.com/track/mirror-candle',
    'active': true,
  },
  {
    'name': "'ANMWE',",
    'duration': NaN,
    'artist': 'DORIS',
    'active': false,
  },
  {
    'name': "'Treasure Hiding',",
    'duration': NaN,
    'artist': 'Cocteau Twins',
    'active': false,
  },
  {
    'name': "'Baby reign',",
    'duration': NaN,
    'artist': 'DORIS',
    'active': false,
  },
  {
    'name': "'Idea June',",
    'duration': NaN,
    'artist': 'Chanel Beads',
    'active': false,
  },
  {
    'name': "'True Altruism',",
    'duration': NaN,
    'artist': 'Chanel Beads',
    'active': false,
  },
  {
    'name': "'Corazón de Poeta',",
    'duration': NaN,
    'artist': 'Jeanette',
    'active': false,
  },
  {
    'name': "'enough',",
    'duration': NaN,
    'artist': 'xaviersobased',
    'active': false,
  },
  {
    'name': "\"I'm Goofy\",",
    'duration': NaN,
    'artist': 'Bladee',
    'active': false,
  },
  {
    'name': "'YOUNG HATIAN NIGGA',",
    'duration': NaN,
    'artist': 'DORIS',
    'active': false,
  },
  {
    'name': "'EVERY MOMENT SPECIAL',",
    'duration': NaN,
    'artist': 'Bladee',
    'active': false,
  },
  {
    'name': "'Twilight Pretender',",
    'duration': NaN,
    'artist': 'James Ferraro',
    'active': false,
  },
  {
    'name': "'A sangre fría',",
    'duration': NaN,
    'artist': 'Forma Norte',
    'active': false,
  },
  {
    'name': "'Mi alma sobre la mesa',",
    'duration': NaN,
    'artist': 'Lorea',
    'active': false,
  },
  {
    'name': "'Collage de Emociones',",
    'duration': NaN,
    'artist': 'Mi Mochila Huele a Semen',
    'active': false,
  },
  {
    'name': "'20230716.1',",
    'duration': NaN,
    'artist': '3D Shape',
    'active': false,
  },
  {
    'name': "'20241201.0',",
    'duration': NaN,
    'artist': '3D Shape',
    'active': false,
  },
  {
    'name': "'Lappis',",
    'duration': NaN,
    'artist': '3D Shape',
    'active': false,
  },
  {
    'name': "'Sirenas',",
    'duration': NaN,
    'artist': 'walmart',
    'active': false,
  },
  {
    'name': "'Se me va la cabeza',",
    'duration': NaN,
    'artist': 'Lorea',
    'active': false,
  },
  {
    'name': "'Siniestro del Jefe',",
    'duration': NaN,
    'artist': 'Lavina Yelb',
    'active': false,
  },
  {
    'name': "'Fishy',",
    'duration': NaN,
    'artist': 'Brennan Jones',
    'active': false,
  },
  {
    'name': '"エンディング",',
    'duration': NaN,
    'artist': 'Utollo Teshikai',
    'active': false,
  },
  {
    'name': 'Blues No. 2',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/blues_no_2.mp3',
    'duration': 178,
    'artist': 'Loren Connors',
    'imageUrl': 'https://f4.bcbits.com/img/a2497257416_10.jpg',
    'sourceUrl': 'https://lorenconnorsnyc.bandcamp.com/track/blues-no-2',
    'active': true,
  },
  {
    'name': 'Sunny side up',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/sunny_side.mp3',
    'duration': 119,
    'artist': 'Connect the Dots',
    'imageUrl': 'https://f4.bcbits.com/img/a1138804993_10.jpg',
    'sourceUrl': 'https://c0nnectthedots.bandcamp.com/track/sunny-side-up',
    'active': true,
  },
  {
    'name': 'Somewhere, the sun is shining',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/sunny_side.mp3',
    'duration': 186,
    'artist': 'Connect the Dots',
    'imageUrl': 'https://f4.bcbits.com/img/a1138804993_10.jpg',
    'sourceUrl': 'https://c0nnectthedots.bandcamp.com/track/somewhere-the-sun-is-shining',
    'active': true,
  },
  {
    'name': 'Sidewalk stroll to Cranberry Park',
    'path': '',
    'url': 'https://music.feed-the-cat.stream/sunny_side.mp3',
    'duration': 80,
    'artist': 'Connect the Dots',
    'imageUrl': 'https://f4.bcbits.com/img/a1636057681_2.jpg',
    'sourceUrl': 'https://c0nnectthedots.bandcamp.com/track/sidewalk-stroll-to-cranberry-park',
    'active': true,
  }
];

/** @returns {boolean} Whether a song is enabled for the web player (defaults to true when omitted). */
export function isSongActive(song) {
  return song.active !== false;
}

/** Songs with a stream URL that are marked active. */
export function getPlayableSongs() {
  return songs.filter((song) => isSongActive(song) && song.url);
}

